import { render, staticRenderFns } from "./CanvasPanel.vue?vue&type=template&id=1241d3ee&scoped=true"
import script from "./CanvasPanel.vue?vue&type=script&lang=js"
export * from "./CanvasPanel.vue?vue&type=script&lang=js"
import style0 from "./CanvasPanel.vue?vue&type=style&index=0&id=1241d3ee&prod&lang=css"
import style1 from "./CanvasPanel.vue?vue&type=style&index=1&id=1241d3ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1241d3ee",
  null
  
)

export default component.exports